import { SegmentedToggle } from '@shared/components/segmented-toggle';
import type React from 'react';

type DisplayQuantityToggleProperties = {
  displayInCases: boolean;
  setDisplayInCases: (displayInCases: boolean) => void;
};

export const DisplayQuantityToggle: React.FC<DisplayQuantityToggleProperties> = ({
  displayInCases,
  setDisplayInCases,
}) => {
  return (
    <SegmentedToggle
      value={displayInCases ? 'cases' : 'units'}
      onChange={(value) => setDisplayInCases(value === 'cases')}
      options={[
        { value: 'units', label: 'Units' },
        { value: 'cases', label: 'Cases' },
      ]}
    />
  );
};
